import { Alert } from '@startuptools/ui/Alert';
import { Typography } from '@startuptools/ui/Typography';
import { useLingui } from '@lingui/react';
import { GqlSeverity, type GqlValidatorMultilangError } from '../../graphql/base-types.graphql';
import React from 'react';
import { ColorPaletteProp } from '@mui/joy/styles';

export const ErrorDisplay = ({
  error,
  actionButton,
  severity,
}: {
  error: GqlValidatorMultilangError | null | undefined;
  severity?: GqlSeverity;
  actionButton?: React.ReactNode;
}) => {
  const { i18n } = useLingui();
  if (!error) return null;
  const { short, long } = error[i18n.locale as 'en' | 'sv'];
  return (
    <Alert color={(severity as ColorPaletteProp) || 'danger'} endDecorator={actionButton}>
      {short}
      <Typography level="body-sm">{long}</Typography>
    </Alert>
  );
};
